import useLocalStore from '../../../hooks/useLocalStore';
import FJTextToFullVideo from './FJTextToFullVideo';
import { useSelector } from 'react-redux';

const FJTextToFullVideoContainer = () => {
    useLocalStore();
    const textToVideoStep = useSelector(state => state.textToVideo.textToVideoStep);

    return <FJTextToFullVideo textToVideoStep={textToVideoStep} />;
};

export default FJTextToFullVideoContainer;
